export default {
      id: "i-tel-usage",
      viewBox: "0 7 24 12",
      url: __webpack_public_path__ + "img/sprite.svg#i-tel",
      toString: function () {
        return this.url;
      }
    }